export default __webpack_public_path__ + "static/media/soon.f8d01a5c.png";